import InventoryConversionForm from './InventoryConversionForm';

const InventoryDisassembly = () => {
  return <InventoryConversionForm mode="disassembly" />;
};

export default InventoryDisassembly;
